import { AlertTriangle, Play, RotateCcw } from "lucide-react";
import type { PoliticsSessionSummary } from "@/lib/politics";
import { Button } from "./primitives";

export function PoliticsActiveSessionDialog({
  session,
  busy,
  onCancel,
  onResume,
  onReplace,
}: {
  session: PoliticsSessionSummary;
  busy: boolean;
  onCancel: () => void;
  onResume: () => void;
  onReplace: () => void;
}) {
  return (
    <div className="politics-dialog-backdrop" role="presentation" onMouseDown={() => !busy && onCancel()}>
      <section
        className="politics-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="politics-active-session-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <span className="politics-dialog__icon"><AlertTriangle /></span>
        <p className="section-label">尚有未完成练习</p>
        <h2 id="politics-active-session-title">先处理上一次答题</h2>
        <p>“{session.bankName}”已完成 {session.answeredCount} / {session.actualCount} 题。你可以继续作答，或结束它并创建当前练习。</p>
        <div className="politics-dialog__actions">
          <Button type="button" variant="ghost" disabled={busy} onClick={onCancel}>取消</Button>
          <Button type="button" disabled={busy} onClick={onReplace}><RotateCcw /> {busy ? "正在创建…" : "结束并新建"}</Button>
          <Button type="button" variant="primary" disabled={busy} onClick={onResume}><Play /> 继续上次练习</Button>
        </div>
      </section>
    </div>
  );
}
